export default "<app-qr-code demo=true></app-qr-code>\n"